


import React, { useEffect } from "react";
import stampImg from '../images/stamp-removebg-preview.png';
import PropTypes from "prop-types";
import { normalizeReporterId } from '../utils/reporterIdFormat';
import cardheader from '../images/card-header.png';
const defaultCSS = `
.press-frame {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}
// .image-div{

// height:105px;
// margin-top:-10px;
// border-radius:10px;
// background:linear-gradient(to right, rgb(5, 1, 37), rgb(46, 34, 115));
// border: 2px solid black;
// }
/* FIXED WIDTH FOR STABLE PNG/PDF CAPTURE */
.press-card {
  width: 380px !important;
  min-width: 380px !important;
  max-width: 380px !important;
  height: 560px;
  background: #fff8c7ff;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
  border: 10px solid #010101;
  font-family: "Noto Sans", "Segoe UI", Roboto, sans-serif;
  color: #222;
}

/* TOP */
.top-heading {
// display: flex;
  width: 100%;
  text-align: center;
  padding: 6px 0;
  font-size: 20px;
  font-weight: 700;
  border-radius: 6px;
  position: relative;
  height: 110px;
 
}
.top-heading img {
 
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 100%;
 
  max-height: 105px;
  object-fit: contain;
}
.top-heading .heading-text {
  background: #a81f2b;
  color: #ffdca6;
  padding: 8px 6px;
  border-radius: 6px;
}

.sub-text { text-align: center; font-size: 15px; font-weight: 1000; margin-top: -6px; }
.gov-line { text-align: center; font-size: 13px; margin-top: 1px; font-weight: 900; }
.rni-line { text-align: center; font-size: 12px; font-weight: 900; margin-top: 1px; }
.gov { color: red; }

/* CENTER BLOCK */
.id-photo-row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 12px;
}
.id-block {
  width: 30%;
  background: #fff9e6;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid rgba(0,0,0,0.06);
  font-size: 12px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.id-label { color: #ff0000ff; }
.valid-label { color: #ff0000ff; }
.valid-value {
  background: #ffe8b3;
  padding: 4px 6px;
  border-radius: 4px;
  border: 1px solid #d1b075;
  font-weight: 800;
}

.photo-center {
  width: 40%;
  display: flex;
  justify-content: center;
}
.photo-box {
  width: 104px;
  height: 140px;
  border: 2px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
  background: #eef2f7;
}
.photo-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.seal-block {
  width: 30%;
  display: flex;
  justify-content: center;
}
.seal-img {
  width: 140px;
  height: 120px;
  object-fit: contain;
  // transform: rotate(-8deg);
  margin-left: -65px;
}

/* FOOTER TEXTS */
.name { margin-top: 6px; text-align: center; font-size: 20px; font-weight: 800; }
.role { margin-top: 2px; text-align: center; font-size: 15px; font-weight: 700; }
.region { text-align: center; font-size: 15px; font-weight: 700; color: #a83b3b; margin-top: 2px; }

/* PRESS BAR */
.press-footer {
  margin-top: 15px;
  width: 100%;
  height: 100px;
  background:linear-gradient(to right, rgb(5, 1, 37), rgb(46, 34, 115));
  color: #fd1111;
  font-size: 94px;
  font-weight: 800;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid black;
  
 
}
  .press-text{
    margin-top: -50px;
    margin-bottom: 20px;
    -webkit-text-stroke: 2px black;
    
    }
`;

export default function PressCard({
  logoUrl = "",
  heading = "RR NEWS TV FASTEST UPDATE",
  subtext = "सोशल एवं इलेक्ट्रॉनिक मीडिया न्यूज़ पोर्टल",
  govLine = "Information & Broadcasting Ministry",
  rni = "UDYAM-UP-59-0118348",
  id = "RUA01540",
  valid = "31/12/2025",
  name = "RR NEWS TV FASTEST UPDATE",
  role = "Reporter",
  region = "Sambhal (U.P.)",
  photo = "https://via.placeholder.com/120x150.png?text=Photo",
  injectStyles = true,
  styleId = "press-card-style", 
  className = "",
}) {

  const displayId = normalizeReporterId(id);

  useEffect(() => {
    if (!injectStyles) return;
    if (document.getElementById(styleId)) return;
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = defaultCSS;
    document.head.appendChild(style);
    return () => {
      const el = document.getElementById(styleId);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className={`press-frame ${className}`}>
      <div className="press-card">

        <div className="top-heading">
          
          {logoUrl ? (
            <div className="image-div">
            <img src={cardheader} alt="Logo" crossOrigin="anonymous" />
            
            </div>
          ) : (
            <div className="heading-text">{heading}</div>
          )}
        
        </div>

        <div className="sub-text">{subtext}</div>
        <div className="gov-line">{govLine}</div>
        <div className="rni-line">
          Government of India —
          <span className="gov"> {rni}</span>
        </div>

        <div className="id-photo-row">
          <div className="id-block">
            <div className="id-label">ID NO</div>
            <div className="id-value">{displayId}</div>
            <div className="valid-label">Valid Upto</div>
            <div className="valid-value">{valid}</div>
          </div>

          <div className="photo-center">
            <div className="photo-box">
              <img src={photo} alt="profile" crossOrigin="anonymous" />
            </div>
          </div>

          <div className="seal-block">
            <img src={stampImg} className="seal-img" alt="seal" crossOrigin="anonymous" />
          </div>
        </div>

        <div className="name">{name}</div>
        <div className="role">{role}</div>
        <div className="region">{region}</div>

        <div className="press-footer"><div className="press-text">PRESS</div></div>
      </div>
    </div>
  );
}

PressCard.propTypes = {
  logoUrl: PropTypes.string,
  heading: PropTypes.string,
  subtext: PropTypes.string,
  govLine: PropTypes.string,
  rni: PropTypes.string,
  id: PropTypes.string,
  valid: PropTypes.string,
  name: PropTypes.string,
  role: PropTypes.string,
  region: PropTypes.string,
  photo: PropTypes.string,
  injectStyles: PropTypes.bool,
  styleId: PropTypes.string,
  className: PropTypes.string,
};


